import { render, staticRenderFns } from "./TheOffcanvas.vue?vue&type=template&id=036ed308&"
import script from "./TheOffcanvas.vue?vue&type=script&lang=js&"
export * from "./TheOffcanvas.vue?vue&type=script&lang=js&"
import style0 from "./TheOffcanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports